import React, { useState, useEffect, useRef } from "react";
import { HTTP } from "../api/http-common";
import { Pencil, ArrowUpRightSquareIcon } from "lucide-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabPanel } from "@radix-ui/react-tabs";
import { useGlobalContext } from "../component/GlobalContext";
import Profile from "../component/Profile";
import '../styling/profilePage.css';
import Swal from "sweetalert2";
import { X } from "lucide-react";
import Dragger from "antd/es/upload/Dragger";
import { message, Upload } from "antd";
import { InboxOutlined } from '@ant-design/icons';
function EventAdd(event) {
  const { globalUserVar } = useGlobalContext();
  const navigate = useNavigate(); 
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState([]);
  const [eventIdError, setEventIdError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [startdateError, setStartDateError] = useState("");
  const [enddateError, setEndDateError] = useState("");
  const [starttimeError, setStartTimeError] = useState("");
  const [endtimeError, setEndTimeError] = useState("");
  // const [priceError, setPriceError] = useState("");
  const [tagError, setTagError] = useState("");
  const [urlError, setUrlError] = useState("");
  const [pagination, setPagination] = useState({ page: '1', limit: '100' });
  const [fileError, setFileError] = useState("");
  const [imagePreview, setImagePreview] = useState(null); // To store image preview URL
  const [selectedTab, setSelectedTab] = useState("profile");
  const [error, setError] = useState(null);
  const [imageError, setImageError] = useState("");

  // For Adress
  const [addressError, setAddressError] = useState("");
  const [cityError, setCityError] = useState("");
  const [eventError, setEventError] = useState("");
  const [stateError, setStateError] = useState("");
  const [postalcodeError, setPostalcodeError] = useState("");
  const [longitudeError, setLongitudeError] = useState("");
  const [latitudeError, setLatitudeError] = useState("");
  const [cityList, setcityList] = useState([]);
  const [eventList, seteventList] = useState([]);

  const handleUploadChange = (info) => {
      const { status } = info.file;
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
        // Handle the uploaded file and update formData if needed
        // setFormData({ ...formData, state: info.file.response });
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    };

  useEffect(() => {
    // console.log(globalUserVar)
    // console.log(typeof(globalUserVar))
    let userData;
    if (typeof (globalUserVar) == 'string') {
      userData = JSON.parse(globalUserVar); // Parse the JSON string
      setName(userData.first_name);
      setEmail(userData.email);
    }
  }, [globalUserVar]);

  const [formData, setFormData] = useState({
    eventid: "",
    title: "",
    description: "",
    start_date: "",
    // end_date: "",
    start_time: "",
    end_time: "",
    price: "",
    // tag: "",
    event_url: "",
    image: "",
    address: "",
    city_id: "",
    state: "",
    postal_code: "",
    longitude: "",
    latitude: "",
  });
  const fileInputRef = useRef(null);

  useEffect(() => {
    setPagination({ page: '1', limit: '100' })
  }, []);




  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      const file = files[0]; // Get the selected file
      if (file) {
        // Generate a preview URL using FileReader
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result); // Set preview URL
          setFormData({ ...formData, image: file }); // Set the file in formData
        };
        reader.readAsDataURL(file); // Convert file to base64 string
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const resetValidationErrors = () => {
    setEventIdError('');
    setTitleError('');
    setDescriptionError('');
    setStartDateError('');
    setEndDateError('');
    setStartTimeError('');
    setEndTimeError('');
    setUrlError('');
    // setPriceError('');
    setTagError('');
    setAddressError('');
    setCityError('');
    setStateError('');
    setPostalcodeError('');
    setLatitudeError('');
    setLongitudeError('');
    setImageError('');
  };

  const validateField = () => {
    resetValidationErrors();
    let checked = true;

    // Event ID Validation
    if (!formData.eventid.trim()) {
      setEventIdError('Please enter an event ID');
      checked = false;
    }

    // Title Validation
    if (!formData.title.trim()) {
      setTitleError('Please enter a title');
      checked = false;
    } else if (formData.title.length < 5) {
      setTitleError("Title must be at least 5 characters");
      checked = false;
    } else if (formData.title.length > 100) {
      setTitleError("Title must not exceed 100 characters");
      checked = false;
    }

    // Description Validation
    if (!formData.description.trim()) {
      setDescriptionError('Please enter a description');
      checked = false;
    } else if (formData.description.length < 5) {
      setDescriptionError("Description must be at least 5 characters");
      checked = false;
    } else {
      setDescriptionError(""); // Clear error if validation passes
    }


    // Start Date Validation
    if (!formData.start_date) {
      setStartDateError("Please enter a start date");
      checked = false;
    }

    // End Date Validation
    // if (!formData.end_date) {
    //   setEndDateError("Please enter an end date");
    //   checked = false;
    // } else if (formData.start_date && formData.end_date < formData.start_date) {
    //   setEndDateError("End date must be after start date");
    //   checked = false;
    // }

    // Start Time Validation
    if (!formData.start_time) {
      setStartTimeError("Please enter a start time");
      checked = false;
    }

    // End Time Validation
    if (!formData.end_time) {
      setEndTimeError("Please enter an end time");
      checked = false;
    } else if (formData.start_time && formData.end_time <= formData.start_time) {
      setEndTimeError("End time must be after start time");
      checked = false;
    }

    // Price Validation
    // if (!formData.price) {
    //   setPriceError("Please enter an entry price");
    //   checked = false;
    // } else if (isNaN(formData.price) || formData.price < 0) {
    //   setPriceError("Price must be a valid non-negative number");
    //   checked = false;
    // }

    if (formData.event_url.trim()) {
      const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/;
      if (!urlPattern.test(formData.event_url.trim())) {
        setUrlError("Please enter a valid URL (e.g., https://example.com)");
        checked = false;
      }
    }

    // Address Validation
    if (!formData.address.trim()) {
      setAddressError("Please enter an address");
      checked = false;
    }

    // City Validation
    if (!formData.city_id) {
      setCityError("Please select a city");
      checked = false;
    }

    // State Validation
    if (!formData.state.trim()) {
      setStateError("Please enter a state");
      checked = false;
    }

    // Postal Code Validation
    if (!formData.postal_code.trim()) {
      setPostalcodeError("Please enter a postal code");
      checked = false;
    } else if (!/^\d{5,6}$/.test(formData.postal_code)) {
      setPostalcodeError("Enter a valid postal code (5-6 digits)");
      checked = false;
    }

    // Latitude Validation
    if (!formData.latitude.trim()) {
      setLatitudeError("Please enter latitude");
      checked = false;
    } else if (isNaN(formData.latitude) || formData.latitude < -90 || formData.latitude > 90) {
      setLatitudeError("Enter a valid latitude (-90 to 90)");
      checked = false;
    }

    // Longitude Validation
    if (!formData.longitude.trim()) {
      setLongitudeError("Please enter longitude");
      checked = false;
    } else if (isNaN(formData.longitude) || formData.longitude < -180 || formData.longitude > 180) {
      setLongitudeError("Enter a valid longitude (-180 to 180)");
      checked = false;
    }

    // Image Validation
    if (!formData.image) {
      setImageError("Please upload an event image");
      checked = false;
    }

    return checked;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateField()) {
      return; // Stop submission if validation fails
    }

    try {
      const access_token = localStorage.getItem("access_token");
      const formDataObj = new FormData();

      // Append all form fields except the image
      Object.keys(formData).forEach((key) => {
        if (key !== "image" && formData[key]) {
          formDataObj.append(key, formData[key]);
        }
      });

      // Append file if selected
      if (fileInputRef.current?.files.length > 0) {
        formDataObj.append("image", fileInputRef.current.files[0]);
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          token: access_token,
        },
      };

      // Debugging: Log FormData
      for (const [key, value] of formDataObj.entries()) {
        console.log(`${key}:`, value);
      }

      // Send the request
      const response = await HTTP.post("/user/event", formDataObj, config);

      if (response.status === 201) {
        Swal.fire({
          title: "Event Added Successfully!",
          icon: "success",
        });
        navigate('/events')

        // Reset form dynamically
        setFormData((prev) =>
          Object.fromEntries(Object.keys(prev).map((key) => [key, ""]))
        );

        // Clear file input field
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.detail || "An unexpected error occurred",
        icon: "error",
      });
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          image: reader.result, // Convert to base64 preview
        }));
        setImageError(""); // Clear error when image is uploaded
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteBannerImage = () => {
    setFormData((prev) => ({
      ...prev,
      image: "",
    }));
    setImageError("Please upload an event image."); // Show validation error
  };

  const fetchCities = async () => {
    try {
      const access_token = localStorage.getItem('access_token');
      const config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };

      const response = await HTTP.post("vendors_address/city", config); // Adjust the URL to your backend endpoint

      if (response.status === 200) {
        setcityList(response.data); // Assume response.data contains the list of cities
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCityError("Failed to load cities.");
    }
  };

  useEffect(() => {
    fetchCities();
  }, []);

  const handleEditClick = async (id) => {
    if (!id) {
      console.error("ID is undefined");
      return;
    }
    navigate(`/event/edit/${id}`);
    console.log("Navigating to:", `/event/edit/${id}`);
  };
  const { id } = useParams();
  useEffect(() => {
    // console.log("Editing event ID:", id);
  }, [id]);

  return (
    <>
      <div className="container mx-auto p-2 md:p-8 ">
        <div>
          <form className="space-y-4 mt-8 common-ui-section-design" onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-[28px] font-medium  pb-2">Event Form</h3>
              {/* <span className="text-[#6c1cff] cursor-pointer">
                  <Pencil className="w-4 h-4" onClick={() => handleEditClick(event.id)} />
                </span> */}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label htmlFor="eventid" className="text-sm font-medium">
                  Event ID
                </label>
                <input
                  type="text"
                  id="eventid"
                  name="eventid"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.eventid}
                  onChange={handleChange}
                />
                {eventIdError && <span className="text-sm text-red-500">{eventIdError}</span>}
              </div>
              {/* Title */}
              <div className="space-y-2">
                <label htmlFor="title" className="text-sm font-medium">
                  Title
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.title}
                  onChange={handleChange}
                />
                {titleError && <span className="text-sm text-red-500">{titleError}</span>}
              </div>

              
              {/* Start Date */}
              <div className="space-y-2">
                <label htmlFor="start_date" className="text-sm font-medium">
                  Start Date
                </label>
                <input
                  type="date"
                  id="start_date"
                  name="start_date"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.start_date}
                  onChange={handleChange}
                />
                {startdateError && <span className="text-sm text-red-500">{startdateError}</span>}
              </div>

              {/* End Date */}
              {/* <div className="space-y-2">
                  <label htmlFor="end_date" className="text-sm font-medium">
                    End Date
                  </label>
                  <input
                    type="date"
                    id="end_date"
                    name="end_date"
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                    value={formData.end_date}
                    onChange={handleChange}
                  />
                  {enddateError && <span className="text-sm text-red-500">{enddateError}</span>}
                </div> */}

              {/* Start Time */}
              <div className="space-y-2">
                <label htmlFor="start_time" className="text-sm font-medium">
                  Start Time
                </label>
                <input
                  type="time"
                  id="start_time"
                  name="start_time"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.start_time}
                  onChange={handleChange}
                />
                {starttimeError && <span className="text-sm text-red-500">{starttimeError}</span>}
              </div>

              {/* End Time */}
              <div className="space-y-2">
                <label htmlFor="end_time" className="text-sm font-medium">
                  End Time
                </label>
                <input
                  type="time"
                  id="end_time"
                  name="end_time"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.end_time}
                  onChange={handleChange}
                />
                {endtimeError && <span className="text-sm text-red-500">{endtimeError}</span>}
              </div>

              {/* Event URL */}
              <div className="space-y-2">
                <label htmlFor="event_url" className="text-sm font-medium">
                  Event URL
                </label>
                <input
                  type="text"
                  id="event_url"
                  name="event_url"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.event_url}
                  onChange={handleChange}
                />
                {urlError && <span className="text-sm text-red-500">{urlError}</span>}
              </div>



              {/* Entry Price */}
              <div className="space-y-2">
                <label htmlFor="price" className="text-sm font-medium">
                  Entry Price
                </label>
                <input
                  type="text"
                  id="price"
                  name="price"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.price}
                  onChange={handleChange}
                />
                <p className="text-sm text-red-500">Leave blank for free</p>
              </div>


              {/* Address */}
              <div className="space-y-2">
                <label htmlFor="address" className="text-sm font-medium">
                  Address
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.address}
                  onChange={handleChange}
                />
                {addressError && <span className="text-sm text-red-500">{addressError}</span>}
              </div>

              {/* City */}
              <div className="space-y-2">
                <label htmlFor="city_id" className="text-sm font-medium">
                  City
                </label>
                <select
                  name="city_id"
                  value={formData.city_id}
                  onChange={handleChange}
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                >
                  <option value="">Select City</option>
                  {Array.isArray(cityList) && cityList.length > 0
                    ? cityList.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name} {/* Assuming city has 'id' and 'name' */}
                      </option>
                    ))
                    : <option value="">No cities available</option>}
                </select>
                {cityError && <span className="text-sm text-red-500">{cityError}</span>}
              </div>

              {/* State */}
              <div className="space-y-2">
                <label htmlFor="state" className="text-sm font-medium">
                  State
                </label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.state}
                  onChange={handleChange}
                />
                {stateError && <span className="text-sm text-red-500">{stateError}</span>}
              </div>

              {/* Postal code */}
              <div className="space-y-2">
                <label htmlFor="postal_code" className="text-sm font-medium">
                  Postal Code
                </label>
                <input
                  type="text"
                  id="postal_code"
                  name="postal_code"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.postal_code}
                  onChange={handleChange}
                />
                {postalcodeError && <span className="text-sm text-red-500">{postalcodeError}</span>}
              </div>

              {/* Latitude */}
              <div className="space-y-2">
                <label htmlFor="latitude" className="text-sm font-medium">
                  Latitude
                </label>
                <input
                  type="text"
                  id="latitude"
                  name="latitude"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.latitude}
                  onChange={handleChange}
                />
                {latitudeError && <span className="text-sm text-red-500">{latitudeError}</span>}
              </div>

              {/* Longitude */}
              <div className="space-y-2">
                <label htmlFor="longitude" className="text-sm font-medium">
                  Longitude
                </label>
                <input
                  type="text"
                  id="longitude"
                  name="longitude"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  value={formData.longitude}
                  onChange={handleChange}
                />
                {longitudeError && <span className="text-sm text-red-500">{longitudeError}</span>}
              </div>

              {/* Event Image */}
              <div className="space-y-2">
                <label htmlFor="image" className="text-sm font-medium">
                  Event Image
                </label>
                <input
                  type="file"
                  id="image"
                  name="image"
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                  onChange={handleImageChange}
                  ref={fileInputRef}
                />
                <p className="text-sm text-red-500">Image Only</p>
                {imageError && <p className="text-sm text-red-500">{imageError}</p>}
                {formData.image && (
                  <div className="relative mt-2">
                    <img
                      src={formData.image}
                      alt="Image Preview"
                      className="upload-image"
                    />
                    <button
                      className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1"
                      onClick={handleDeleteBannerImage}
                      type="button"
                    >
                      <X />
                    </button>
                  </div>
                )}
              </div>
              {/* <Dragger
              name="file"
              action="/uplod"
              onChange={handleUploadChange}
              multiple={false}
              showUploadList={false}
              // beforeUpload={beforeUpload} 
              >
<p className="ant-upload-drag-icon">
        <InboxOutlined/>
      </p>
      <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">
              Upload the state here (only 1 file allowed).
            </p>
              </Dragger> */}


              {/* Description */}
              <div className="space-y-2">
                <label htmlFor="description" className="text-sm font-medium">
                  Description
                </label>
                <textarea
                  type=""
                  // row="4"
                  id="description"
                  name="description"
                  className="w-full p-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.description}
                  onChange={handleChange}
                />
                {descriptionError && <span className="text-sm text-red-500">{descriptionError}</span>}
              </div>

            </div>
            <button
              type="submit"
              className="theme-button text-white px-4 py-2 rounded-md shadow-sm"
            >
              Submit
            </button>
          </form>

        </div>
      </div>

    </>
  )
}

export default EventAdd;